import { IsNotEmpty, IsArray, IsString } from 'class-validator';

export class CacheDeleteDTO {

    @IsNotEmpty()
    @IsArray()
    @IsString({
        each: true
    })
    keys: Array<string>;

}
